@if (localUser.userData) {
    <!-- Chat container-->
    <div
        name="ChatBotRow"
        class="tw-flex tw-flex-row"
        [ngClass]="[
            (chatLoading$ | async) && !chatHasInitialized
                ? 'tw-pointer-events-none'
                : 'tw-pointer-events-auto',
            panelOpenState && chatHasInitialized
                ? 'tw-h-[630px]'
                : 'tw-h-[unset]'
        ]"
    >
        <div name="ThreadListContainer" class="tw-flex">
            @if (threadMenuOpen && panelOpenState) {
                <app-thread-list
                    [userThreads$]="threads$"
                    [threadBuffering$]="threadBuffering$"
                    [currentChat$]="chat$"
                    [chatLoading$]="chatLoading$"
                    class="tw-w-[300px] tw-shadow-[0px,4px,6px,rgba(0,0,0,0.1)] tw-rounded-lg tw-h-full"
                    (closeThreadMenu)="threadMenuOpen = false"
                    (newThreadSelected)="loadSelectedThread($event)"
                    (threadsToDelete)="deleteThreads($event)"
                    [newThreadIncoming]="newThreadBeingSaved$"
                    (createNewThread)="createNewThread()"
                />
            }
        </div>

        <div name="ChatBot" class="tw-flex">
            <mat-expansion-panel
                id="aiPanel"
                #panel
                class="tw-w-[450px] tw-flex tw-flex-col"
                (opened)="
                    panelOpenState = true;
                    !chatHasInitialized && !chat && createInitialThread()
                "
                [ngClass]="[
                    threadMenuOpen && panelOpenState ? 'tw-rounded-l-none' : ''
                ]"
                (closed)="panelOpenState = false"
                [disabled]="!localUser.userData"
            >
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        @if (
                            (chatLoading$ | async) && !chat && !threadMenuOpen
                        ) {
                            <mat-spinner class="tw-mr-2" [diameter]="20" />
                        }
                        Portal AI Document Bot
                    </mat-panel-title>
                    <mat-panel-description class="tw-max-w-fit tw-relative">
                        Click to {{ panelOpenState ? "collapse" : "expand" }}
                    </mat-panel-description>
                </mat-expansion-panel-header>

                @if (threadMenuOpen && messages.length === 0) {
                    <div
                        class="tw-min-h-full tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center"
                    >
                        <mat-spinner [diameter]="60"></mat-spinner>
                    </div>
                }

                <div class="tw-flex tw-flex-col tw-h-full tw-max-h-[550px]">
                    <ng-container *ngIf="chat$ | async as chat">
                        <div
                            class="tw-flex-col tw-w-full tw-h-full tw-max-w-[450px]"
                        >
                            <app-chat-header
                                class="tw-w-full"
                                [currentChat]="chat$"
                                (openDialogEvent)="setPanelState($event)"
                                (displayThreadMenu)="
                                    threadMenuOpen = !threadMenuOpen
                                "
                            />
                            <div
                                class="tw-relative tw-flex tw-flex-col tw-flex-1 tw-max-h-[500px] tw-h-[500px]"
                            >
                                <div
                                    #scrollContainer
                                    class="tw-flex tw-flex-col tw-gap-2 tw-max-h-[365px] tw-overflow-y-auto tw-h-full tw-bg-[rgba(211,211,211,0.349)] tw-shadow-[inset_0px_0px_10px_rgba(0,0,0,0.5)]"
                                >
                                    <ng-container
                                        *ngFor="
                                            let msg of messages;
                                            let i = index;
                                            trackBy: trackByCreated
                                        "
                                    >
                                        <app-chat-message
                                            [msg]="msg"
                                            [predecessor]="
                                                i - 1 >= 0
                                                    ? messages[i - 1]
                                                    : null
                                            "
                                            [localUser]="localUser"
                                        />
                                    </ng-container>

                                    <app-typing-indicator
                                        [aiBuffering]="aiBuffering$ | async"
                                    />
                                </div>

                                <app-chat-controls
                                    class="tw-w-full"
                                    (sendMessage)="sendMessage($event)"
                                    [aiBuffering$]="aiBuffering$"
                                />
                            </div>
                        </div>
                    </ng-container>
                </div>
            </mat-expansion-panel>
        </div>
    </div>
}
